export enum ZLayers {
  control = 50,
  footer = 90,
  sidebar = 100,
  sidebarControls = 105,
  header = 110,
  uiElement = 200,
  loading = 700,
  modal = 800,
  notification = 900,
  tooltip = 1000,
}

export default ZLayers
